/** Canonical web paths for Phase 1 History API routing. */
export const PATHS = {
    splash: '/',
    login: '/login',
    register: '/register',
    dashboard: '/dashboard',
    bills: '/bills',
    users: '/users',
    reports: '/reports',
    settings: '/settings',
    bookings: '/bookings',
    rivalSearch: '/rival-search',
    ratings: '/ratings',
    video: '/video',
    notifications: '/notifications',
    home: '/home',
    cabinet: '/cabinet',
    score: '/score',
} as const

export type AppPath = (typeof PATHS)[keyof typeof PATHS]

/** Staff overlay screens that still render the dashboard underneath. */
export const STAFF_OVERLAY_PATHS = [
    PATHS.bills,
    PATHS.users,
    PATHS.reports,
    PATHS.settings,
    PATHS.notifications,
    PATHS.ratings,
    PATHS.video,
] as const

export type StaffOverlayPath = (typeof STAFF_OVERLAY_PATHS)[number]

export function isStaffOverlayPath(pathname: string): pathname is StaffOverlayPath {
    return (STAFF_OVERLAY_PATHS as readonly string[]).includes(pathname)
}

export function isStaffShellPath(pathname: string): boolean {
    return pathname === PATHS.dashboard || isStaffOverlayPath(pathname)
}

export function roleHomePath(canManageTables: boolean, isService?: boolean): string {
    if (isService) return PATHS.score
    return canManageTables ? PATHS.dashboard : PATHS.home
}
